WiseMetering.Views.DestroyOpportunity = WiseMetering.Views.Modal.Destroy.extend({
    title: () => i18next.t('modal.title.opportunities.destroy')
});
